<p-toast></p-toast>

<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">
      {{ 'layout.configurations.pool.title' | translate }}
    </p>

   <p-button
  *emPermission="Permission.CONFIG_PERFORMANCE"
  class="p-button-success"
  icon="pi pi-plus"
  severity="success"
  (onClick)="includeForm()">
</p-button>
  </div>

  <p-table
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center"
    [value]="filters"
    styleClass="w-full p-datatable-sm">

    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="label" class="bg-white">
          {{ 'layout.configurations.pool.label' | translate }}
          <p-sortIcon field="label" />
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-filter>
      <tr>
        <td>{{ filter.label }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>